import { ISystemCode } from "./systemCode.types";

export class SystemCode implements ISystemCode {
  code: string;
  codeGroup: string;
  parentCode: string;
  name: string;
  isUsable: boolean;
  displayOrder: number;
  priorityOrder: number;

  constructor(data: ISystemCode) {
    this.code = data.code;
    this.codeGroup = data.codeGroup;
    this.parentCode = data.parentCode;
    this.name = data.name;
    this.isUsable = data.isUsable;
    this.displayOrder = data.displayOrder;
    this.priorityOrder = data.priorityOrder;
  }
}
